import React, { createContext, useState } from 'react';
import theme from 'theme';
import formatMediaQuery from 'utils/format-media-query';
import useMount from "utils/hooks/useMount";


const screenNumbers = Object.keys(theme.screens).reduce(
  (acc, curr, index) => {
    acc[curr] = index + 1;
    return acc;
  },
  { xs: 0 },
);


// Context

export const BreakpointContext = createContext();


// Provider

export const BreakpointProvider = ({ children }) => {
  const [currentSize, setCurrentSize] = useState('xs');

  const isBelow = testSize => (
    screenNumbers[currentSize] < screenNumbers[testSize]
  );

  const isBetween = (minSize, maxSize) => (
    screenNumbers[currentSize] >= screenNumbers[minSize]
    && screenNumbers[currentSize] < (screenNumbers[maxSize] || 100)
  );

  const createHandler = (query, size) => {
    window.matchMedia(query).addListener((e) => {
      if (e.matches) setCurrentSize(size);
    });
  };

  const initialQueryCheck = (query, size) => {
    if (window.matchMedia(query).matches) {
      setCurrentSize(size);
    }
  };

  const handleQuery = (query, size) => {
    initialQueryCheck(query, size);
    createHandler(query, size);
  };

  const registerBreakpoints = () => {
    const breakpoints = Object.entries(theme.screens);
    breakpoints.forEach(([size, sizeValue], index) => {
      let query;
      if (index === breakpoints.length - 1) {
        query = formatMediaQuery({ minWidth: sizeValue });
      } else {
        query = formatMediaQuery({
          minWidth: breakpoints[index][1],
          maxWidth: breakpoints[index + 1][1],
        });
      }
      handleQuery(query, size);
    });

    // Register media query for default/smallest size
    const defaultQuery = formatMediaQuery({ maxWidth: breakpoints[0][1] });
    handleQuery(defaultQuery, 'xs');
  };

  useMount(registerBreakpoints);


  return (
    <BreakpointContext.Provider
      value={{
        size: currentSize,
        isBetween,
        isBelow,
      }}
    >
      {children}
    </BreakpointContext.Provider>
  );
};


// Higher Order Component

export const withBreakpoint = Component => props => (
  <BreakpointContext.Consumer>
    {context => <Component {...props} breakpointContext={context} />}
  </BreakpointContext.Consumer>
);
